import axios from "axios";
import { IQuizRequestParams } from "./type";
import { toast, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { authToken } from "./utils/constants";
// var qs = require("qs");

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const Fade = cssTransition({
  enter: "FadeIn",
  exit: "FadeOut",
});

toast.configure({
  position: "top-center",
  autoClose: 1000,
  limit: 1,
  hideProgressBar: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
});

export const notifyError = (message: string) =>
  toast.error(message, {
    className: "react-toast-error",
    transition: Fade,
  });

export const notifySuccess = (message: string) =>
  toast.success(message, {
    className: "react-toast-success",
    transition: Fade,
  });

export const requestQuizById = async (params: IQuizRequestParams) => {
  const { type, id } = params;
  return axios.get(`${BASE_URL}${type}/${id}?u=${Date.now()}`, {
    headers: { Authorization: authToken },
  });
};

// export const saveQuizProgressRequest = async (params: any) => {
//   const correctAnswer = params["correctAnswer"];
//   delete params["correctAnswer"];
//   const data = {
//     collectionName: "save_progress",
//     document: params,
//   };
//   return axios
//     .post(process.env.REACT_APP_PROGRESS_URL as string, data, {
//       headers: { Authorization: authToken },
//     })
//     .then((result: any) => {
//       if (correctAnswer === true) {
//         if (allowSound()) {
//           correctSound.play();
//           window.setTimeout(() => {
//             correctSound.pause();
//             inCorrectSound.currentTime = 0;
//           }, 1500);
//         }

//         notifySuccess("Correct Answer");
//       } else if (correctAnswer === false) {
//         if (allowSound()) {
//           inCorrectSound.play();
//           window.setTimeout(() => {
//             inCorrectSound.pause();
//             inCorrectSound.currentTime = 0;
//           }, 1500);
//         }

//         notifyError("Incorrect Answer");
//       } else {
//         notifySuccess("Saved successfully");
//       }
//       return result;
//     })
//     .catch(() => {
//       notifyError("Something went wrong, please try again");
//     });
// };

export const updateQuizProgressRequest = async (params: any) => {
  const data = {
    collectionName: "save_progress",
    filter: {
      userID: params.userID,
      quizID: params.quizID,
    },
    document: params,
  };
  return axios
    .put(process.env.REACT_APP_PROGRESS_URL as string, data, {
      headers: { Authorization: authToken },
    })
    .then(() => {})
    .catch(() => {
      notifyError("Something went wrong, please try again");
    });
};
// export const checkAndSaveQuizProgressRequest = async (params: any) => {
//   const data = {
//     collectionName: "save_progress",
//     filter: {
//       userID: params.userID,
//       quizID: params.quizID,
//     },
//     document: params,
//   };
//   return axios
//     .put(process.env.REACT_APP_PROGRESS_URL as string, data, {
//       headers: { Authorization: authToken },
//     })
//     .then(() => {
//       notifySuccess("Saved successfully");
//     })
//     .catch(() => {
//       notifyError("Something went wrong, please try again");
//     });
// };

export const getQuizProgress = async (params: any) => {
  return axios.get(process.env.REACT_APP_PROGRESS_URL as string, {
    params,
    headers: {
      Authorization: authToken,
      // 'Content-Type': 'application/json',
    },
  });
};

export const getCustomQuiz = async (params: any) => {
  const { quizID, userID } = params;
  const dbUrl = process.env.REACT_APP_CUSTOM_QUIZ as string;
  //const endPoint = `${dbUrl}/question`;
  return axios.get(dbUrl, {
    params: { user_id: userID, quiz_id: quizID },
    headers: {
      Authorization: authToken,
    },
  });
};

export const saveQuiz = (params: any) => {
  return new Promise((resolve, reject) => {
    let url =
      (process.env.REACT_APP_SAVE_QUIZ_URL as string) + "save-quiz-info";
    return axios
      .post(url, params, { headers: { Authorization: authToken } })
      .then(() => {
        notifySuccess("Quiz submit successfully");
        resolve(true);
      })
      .catch((err) => {
        reject(err);
        notifyError("Something went wrong, please try again");
      });
  });
};

// export const saveQuizAnalyticData = (params: any) => {
//   let url = process.env.REACT_APP_SUBMIT_URL as string;
//   // , { headers: { 'Authorization': token } }
//   return axios
//     .post(url, qs.stringify(params))
//     .then(() => {
//       return true;
//       //   notifySuccess('Quiz saved successfully')
//     })
//     .catch(() => {
//       notifyError("Something went wrong, please try again");
//       return false;
//     });
// };

export const deleteQuizProgressData = (params: any) => {
  const data = {
    collectionName: "save_progress",
    filter: {
      userID: Number(params.userID),
      quizID: Number(params.quizID),
    },
  };
  const headers = {
    Authorization: authToken,
    "Content-Type": "application/json",
  };
  // , { headers: { 'Authorization': token } }
  return axios
    .delete(process.env.REACT_APP_PROGRESS_URL as string, {
      data: data,
      headers: headers,
    })
    .then(() => {
      //   notifySuccess('Deleted successfully')
    })
    .catch(() => {
      notifyError("Something went wrong, please try again");
    });
};
 
export const completeQuiz = (params: any) => {
  let data = {
    action: "ntml_mark_quiz_complete",
    info: {
      userId: params.user_id,
      quizData: {
        quiz: params.quiz_id,
        pass: 1,
        course: params.course_id,
        lesson: params.lesson_id,
        topic: 0,
      },
    },
  };
  const bodyFormData = new FormData();
  bodyFormData.append("action", data.action);
  bodyFormData.append("info", JSON.stringify(data.info));
  let url = process.env.REACT_APP_SUBMIT_URL as string;
  return axios.post(url, bodyFormData, {
    headers: {
      Authorization: authToken,
      "Content-Type": "multipart/form-data",
    },
  });
};
